import React from 'react'

const SvgDataCheckFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 8H2V4c0-1.333.667-2 2-2h15.99C21.33 2 22 2.668 22 4v4zM6.707 6.707a1 1 0 11-1.414-1.414 1 1 0 011.414 1.414zM2 14h5.785a3 3 0 014.299-.134l.013.012.122.122h1.54l4-4H2v4zm12.58 2l2.001-2h.006l3.695-3.695.023-.023.002-.002a1 1 0 011.071-.206h.002a1 1 0 01.327.217l.001.002a.994.994 0 01.218.326v.002a1.001 1.001 0 01.075.361v.031l-.001.032a1 1 0 01-.08.348v.002a1 1 0 01-.199.299l-.002.001-.002-.001a.964.964 0 01-.022.022l-1.692 1.69v.006l-.588.588-2 2-3.72 3.72a1 1 0 01-1.413 0L9.28 16.717A1 1 0 019 16.015V16a.998.998 0 011.694-.702l.703.702h-.007l1.598 1.598L14.588 16h-.008zm7.14-4.305a.803.803 0 01-.023.023l.023-.023zm-.729-1.697c.023 0 .046 0 .068.002h-.117l.05-.002zM20.243 16l-5.133 5.134a3 3 0 01-1.852.866h-.538a3 3 0 01-1.852-.866L7.854 18.12l-.012-.012A3 3 0 017 16H2v3.92C2 21.307 2.667 22 4 22h8.72a3.007 3.007 0 00.538 0H20c1.333 0 2-.693 2-2.08V16h-1.757zM6 13a1 1 0 100-2 1 1 0 000 2zm.707 5.707a1 1 0 11-1.414-1.414 1 1 0 011.414 1.414z'
    />
    <path d='M13.047 20h-.117a.957.957 0 00.117 0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.282 10.305a1 1 0 111.414 1.414l-8 8a1 1 0 01-1.414 0l-3.001-3a1 1 0 011.414-1.415l2.293 2.294 7.294-7.293z'
    />
  </svg>
)

export default SvgDataCheckFilled
